import * as React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import { Alert, TextField, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { app } from '../app.js';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import clsx from 'clsx';
import { GridColDef, DataGrid, GridCellParams } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { Grid } from 'react-loader-spinner';
const ratingLabels = {
    0: 'NF',
    1: 'Scarso',
    2: 'Minimo',
    3: 'Sufficiente',
    4: 'Buono',
    5: 'Ottimo',
    
};

const Choice4Rate = (props) => {
    const { name, currentValue, onChange, label } = props;
   // console.log("Choice4Rate "+name,currentValue);
    const handleClick = (value) => {
        onChange(value);
    };

    return (
        <div>
             
                <Typography variant="h6" component="h6">{label}</Typography>
            
            <ButtonGroup sx={{ mb: 3 }} variant="contained" aria-label={`${name} button group`}>
                {Object.entries(ratingLabels).map(([value, label]) => (
                    <Button sx={{  float: 'left' }}
                        key={name+'-'+value}
                        variant={currentValue === parseInt(value) || (value==0 && !currentValue) ? 'contained' : 'outlined'} 
                        onClick={() => handleClick(parseInt(value))}
                    >
                        {label}
                    </Button>
                ))}
            </ButtonGroup>
        </div>
    );
};
const IntInput = (props) => {
    const { name, currentValue, onChange, label, dataType } = props;

    const handleChange = (event) => {
        onChange(parseInt(event.target.value, 10));
    };

    return (
        <div>
                <Typography variant="h6" component="h6">{label}</Typography>
            <TextField
                variant="outlined"
                value={(currentValue ? currentValue : '')}
                onChange={handleChange}
                label=""
                type={dataType}
                min="0"
            />
        </div>
    );
};

const TextareaInput = (props) => {
    const { name, currentValue, onChange, label, dataType } = props;

    const handleChange = (event) => {
        onChange(parseInt(event.target.value, 10));
    };

    return (
        <div>
            <Typography variant="h6" component="h6">{label}</Typography>
            <TextField
                variant="outlined"
                value={(currentValue ? currentValue : '')}
                onChange={handleChange}
                label=""
                type={dataType}
                multiline
                rows={4}
                fullWidth
            />
        </div>
    );
};
const Choice4RateAndQty = (props) => {
    const { name, currentRate, currentQty, onRateChange, onQtyChange, label } = props;

    const handleRateClick = (value) => {
        onRateChange(value);
    };

    const handleQtyChange = (event) => {
        onQtyChange(event.target.value);
    };

    return (
        <div>
            <div>{label}</div>
            <ButtonGroup variant="contained" aria-label={`${name} rate button group`}>
                {Object.entries(ratingLabels).map(([value, label]) => (
                    <Button 
                        key={value}
                        variant={currentRate === parseInt(value) ? 'outlined' : 'contained'} 
                        onClick={() => handleRateClick(parseInt(value))}
                    >
                        {label}
                    </Button>
                ))}
            </ButtonGroup>
            <div>
                <label htmlFor={`${name}-qty`}>Quantity:</label>
                <input 
                    id={`${name}-qty`} 
                    type="number" 
                    value={currentQty} 
                    onChange={handleQtyChange} 
                />
            </div>
        </div>
    );
};
const CheckComponent = ({ name, label, currentValue, onChange }) => {
    const handleChange = (event) => {
        onChange(event.target.checked);
    };

    return (
        <FormControlLabel
            control={
                <Checkbox
                    key={name}
                    checked={currentValue}
                   onChange={handleChange}
                    name={name}
                />
            }
            label={label}
        />
    );
};
const ratingMapping = {
    "Choice4Rate": Choice4Rate,
    "IntInput": IntInput,
    "TextareaInput": TextareaInput,
    "CheckComponent": CheckComponent
}
const manovre={
    "checklist": {
            "checklist": {
                "short": "CHECK",
                "name": "1° Fase e Checklist",
                "labelScheda": "1° Fase e checklist",
                "key": "checklist",
            //    "type": CheckComponent,
                "typeText":"CheckComponent"
            }
    },
    "inversioni":{
        "inversionisp": {
            "short": "INVSP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "inversionisp",
        //    "type": CheckComponent,
            "typeText":"CheckComponent"
        },
        "inversioniqt": {
            "short": "INVQT",
            "name": "Numero",
            "labelScheda": "Numero",
            "key": "inversioniqt",
            "dataType":"number",
        //    "type": IntInput,
            "typeText":"IntInput"
        },
        "inversionivoto": {
            "short": "INV",
            "name": "Voto",
            "labelScheda": "Voto",
            "key": "inversionivoto",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        
        
    },
    "certificateB":{
            "certnott": {
                "short": "CERT NOTT",
                "name": "Guida certificata notturna",
                "labelScheda": "Notturna",
                "key": "certnott",
            //    "type": CheckComponent,
                "typeText":"CheckComponent"
            },
            "certext": {
                "short": "CERT EXT",
                "name": "Guida certificata extraurbana",
                "labelScheda": "Extraurbana",
                "key": "certext",
            //    "type": CheckComponent,
                "typeText":"CheckComponent"
            },
            "certaut": {
                "short": "CERT AUT",
                "name": "Guida certificata autostrada",
                "labelScheda": "Autostrada",
                "key": "certaut",
            //    "type": CheckComponent,
                "typeText":"CheckComponent"
            }
        },
    "parcheggioS":{
        "parchssp": {
            "short": "PARCHSSP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "parchssp",
        //    "type": CheckComponent,
            "typeText":"CheckComponent"
        },
        "parchsqt": {
            "short": "PARCHSQT",
            "name": "Numero",
            "labelScheda": "Numero",
            "key": "parchsqt",
            "dataType":"number",
        //    "type": IntInput,
            "typeText":"IntInput"
        },
        "parchsvoto": {
            "short": "PARCHS",
            "name": "Voto",
            "labelScheda": "Voto",
            "key": "parchsvoto",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        }
    },
    "parcheggioL":{
        "parchlsp": {
            "short": "PARCHLSP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "parchlsp",
        //    "type": CheckComponent,
            "typeText":"CheckComponent"
        },
        "parchlqt": {
            "short": "PARCHLQT",
            "name": "Numero",
            "labelScheda": "Numero",
            "key": "parchlqt",
            "dataType":"number",
        //    "type": IntInput,
            "typeText":"IntInput"
        },
        "parchlvoto": {
            "short": "PARCHL",
            "name": "Voto",
            "labelScheda": "Voto",
            "key": "parchlvoto",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        
    },
    "aggancioSgancio":{
                    
        "aggsgasp": {
            "short": "AGGSGASP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "aggsgasp",
            "typeText":"CheckComponent"
        },
        
        "aggsgaqt": {
            "short": "AGGSGAQT",
            "name": "Numero",
            "labelScheda": "Numero",
            "key": "aggsgaqt",
            "typeText":"IntInput"
        },
        "messaSicurezza": {
            "short": "MESSASICUREZZA",
            "name": "Messa in sicurezza",
            "labelScheda": "Messa in sicurezza",
            "key": "messaSicurezza",
            "typeText":"CheckComponent"
        },
    },
    "ingressoAutostrada":{
                    
        "ingautosp": {
            "short": "INGAUTOSP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "ingautosp",
            "typeText":"CheckComponent"
        },
        "ingauto": {
            "short": "INGAUTO",
            "name": "Voto",
            "labelScheda": "Voto",
            "key": "ingauto",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        }
    },
    "uscitaAutostrada":{                    
        "uscautosp": {
            "short": "USCAUTOSP",
            "name": "Spiegato",
            "labelScheda": "Spiegato",
            "key": "uscautosp",
            "typeText":"CheckComponent"
        },
        "uscauto": {
            "short": "USCAUTO",
            "name": "Voto",
            "labelScheda": "Voto",
            "key": "uscauto",
            "typeText":"Choice4Rate"
        }
    },
    "marciaSpeciali":{
        "part": {
            "short": "PART",
            "name": "Partenza",
            "labelScheda": "Partenza",
            "key": "part",
       //     "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        "marc": {
            "short": "MARC",
            "name": "Marce",
            "labelScheda": "Marce",
            "key": "marc",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        "svol": {
            "short": "SVOL",
            "name": "Svolte",
            "labelScheda": "Svolte",
            "key": "svol",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        "rot": {
            "short": "ROT",
            "name": "Rotonde",
            "labelScheda": "Rotonde",
            "key": "rot",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        "gestIngombri": {
            "short": "GESTING",
            "name": "Gestione ingombri",
            "labelScheda": "Ingombri",
            "key": "gestIngombri",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        
        "usoComandi": {
            "short": "USOCOMANDI",
            "name": "Uso comandi",
            "labelScheda": "Uso comandi",
            "key": "usoComandi",
        //    "type": Choice4Rate,
            "typeText":"Choice4Rate"
        },
        
    }

};
const obj = {
    "singleLabel": "Guida",
    "label": "Guide",
    "orderBy": "date",
    "questionCfg": {
        "categoryScheme": {
            "a": {
                "Marcia": {
                    "part": {
                        "short": "PART",
                        "name": "Partenza",
                        "labelScheda": "Partenza",
                        "key": "part",
                   //     "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "marc": {
                        "short": "MARC",
                        "name": "Marce",
                        "labelScheda": "Marce",
                        "key": "marc",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "fren": {
                        "short": "FREN",
                        "name": "Frenata",
                        "labelScheda": "Frenata",
                        "key": "fren",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "circ": {
                        "short": "CIRC",
                        "name": "Circolazione",
                        "labelScheda": "Circolazione",
                        "key": "circ",
                     //   "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "svolrot": {
                        "short": "SVOLROT",
                        "name": "Svolte e rotonde",
                        "labelScheda": "Sv. E rotonde",
                        "key": "svolrot",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "pes": {
                        "short": "PES",
                        "name": "Gestione pesi",
                        "labelScheda": "Gestione pesi",
                        "key": "pes",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "pislen": {
                        "short": "PISLEN",
                        "name": "Pista lenta",
                        "labelScheda": "Pista lenta",
                        "key": "pislen",
                     //   "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "pisvel": {
                        "short": "PISVEL",
                        "name": "Pista veloce",
                        "labelScheda": "Pista veloce",
                        "key": "pisvel",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    
                },
                "Inversioni": manovre["inversioni"],
                "Teoria": manovre["checklist"],
                
                "Certificate": {
                    "cert3pista": {
                        "short": "3h PISTA",
                        "name": "3 ore pista",
                        "labelScheda": "3h Pista",
                        "key": "cert3pista",
                    //    "type": CheckComponent,
                        "typeText":"CheckComponent"
                    },
                    "cert2individuale": {
                        "short": "2H PISTA",
                        "name": "2 ore individuale",
                        "labelScheda": "2h IND",
                        "key": "cert2individuale",
                    //    "type": CheckComponent,
                        "typeText":"CheckComponent"
                    },
                },
                
            },
            "b": {
                "Marcia": {
                    "part": {
                        "short": "PART",
                        "name": "Partenza",
                        "labelScheda": "Partenza",
                        "key": "part",
                   //     "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "marc": {
                        "short": "MARC",
                        "name": "Marce",
                        "labelScheda": "Marce",
                        "key": "marc",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "svol": {
                        "short": "SVOL",
                        "name": "Svolte",
                        "labelScheda": "Svolte",
                        "key": "svol",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "rot": {
                        "short": "ROT",
                        "name": "Rotonde",
                        "labelScheda": "Rotonde",
                        "key": "rot",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    
                },
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Teoria": manovre["checklist"],
                "Certificate": manovre["certificateB"]
                
            },
            "bauto": {
                "Marcia": {
                    "part": {
                        "short": "PART",
                        "name": "Partenza",
                        "labelScheda": "Partenza",
                        "key": "part",
                   //     "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "marc": {
                        "short": "MARC",
                        "name": "Marce",
                        "labelScheda": "Marce",
                        "key": "marc",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "svol": {
                        "short": "SVOL",
                        "name": "Svolte",
                        "labelScheda": "Svolte",
                        "key": "svol",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "rot": {
                        "short": "ROT",
                        "name": "Rotonde",
                        "labelScheda": "Rotonde",
                        "key": "rot",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    
                },
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Teoria": manovre["checklist"],
                "Certificate": manovre["certificateB"],
                
            },
            
            "be": {
                "Marcia": {
                    "part": {
                        "short": "PART",
                        "name": "Partenza",
                        "labelScheda": "Partenza",
                        "key": "part",
                   //     "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "marc": {
                        "short": "MARC",
                        "name": "Marce",
                        "labelScheda": "Marce",
                        "key": "marc",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "svol": {
                        "short": "SVOL",
                        "name": "Svolte",
                        "labelScheda": "Svolte",
                        "key": "svol",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    "rot": {
                        "short": "ROT",
                        "name": "Rotonde",
                        "labelScheda": "Rotonde",
                        "key": "rot",
                    //    "type": Choice4Rate,
                        "typeText":"Choice4Rate"
                    },
                    
                },
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Aggancio/Sgancio": manovre["aggancioSgancio"],
                "Teoria": {
                    "checklist": {
                        "short": "CHECK",
                        "name": "1° Fase e Checklist",
                        "labelScheda": "1° Fase e checklist",
                        "key": "checklist",
                        "typeText":"CheckComponent"
                    }
                }
                
            },
            "c": {
                "Marcia": manovre["marciaSpeciali"],
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Aggancio/Sgancio": manovre["aggancioSgancio"],
                "Teoria": {
                    "checklist": {
                        "short": "CHECK",
                        "name": "1° Fase e Checklist",
                        "labelScheda": "1° Fase e checklist",
                        "key": "checklist",
                        "typeText":"CheckComponent"
                    }
                }
                
            },
            
            "ce": {
                
                "Marcia": manovre["marciaSpeciali"],
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Aggancio/Sgancio": manovre["aggancioSgancio"],
                "Teoria": {
                    "checklist": {
                        "short": "CHECK",
                        "name": "1° Fase e Checklist",
                        "labelScheda": "1° Fase e checklist",
                        "key": "checklist",
                        "typeText":"CheckComponent"
                    }
                }
                
            },
            "d": {
                "Marcia": manovre["marciaSpeciali"],
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Teoria": {
                    "checklist": {
                        "short": "CHECK",
                        "name": "1° Fase e Checklist",
                        "labelScheda": "1° Fase e checklist",
                        "key": "checklist",
                        "typeText":"CheckComponent"
                    }
                }
                
            },
            "de": {
                
                "Marcia": manovre["marciaSpeciali"],
                "Inversioni": manovre["inversioni"],                
                "Parcheggio S": manovre["parcheggioS"],                
                "Parcheggio L": manovre["parcheggioL"],
                "Ingr. autostrada": manovre["ingressoAutostrada"],                
                "Uscita autostrada": manovre["uscitaAutostrada"],
                "Aggancio/Sgancio": manovre["aggancioSgancio"],
                "Teoria": {
                    "checklist": {
                        "short": "CHECK",
                        "name": "1° Fase e Checklist",
                        "labelScheda": "1° Fase e checklist",
                        "key": "checklist",
                        "typeText":"CheckComponent"
                    }
                }
                
            },
        }
    },
    "views":{
        "table":{  
            "debug":false,
            "autoLoad":false,
            "filter":true,
            "defaultTab":0,
            "fieldList":[        
                {"field":'id', headerName:'ID', width:70 },          
                {"field":'candidatoName', headerName:'Candidato', width:150},   
                
                {"field":'istruttoreBreve', headerName:'Istruttore', width:150},                     
                {"field":"candidato",headerName:"Candidato ID", width:150, type:'string', filter:{gridProp:{xs:12},match:["equalTo"] }},
                {"field":"istruttore",headerName:"Istruttore ID", width:150, type:'string', filter:{gridProp:{xs:12},match:["equalTo"] }},
                
                {"field":'date', headerName:'Data', width:150,type:'datetime', filter:{type:"datetime",gridProp:{xs:12} }, valueFormatter: (params) => (params.value?dayjs(params.value).format('DD/MM/YYYY H.mm'):""), },                        
                {"field":'durata', headerName:'Durata', width:70, valueGetter:(params)=> {
                    const options=app.durate;
                    if (!options[params.value]) return "Non impostato";
                    return options[params.value];
                } },          
                {"field":'category', headerName:'Categoria', filter:{gridProp:{xs:12},type:"select",options:[{value:"a",label:"A"}, {value:"b",label:"B"}, {value:"bauto",label:"B AUTO"}, {value:"be",label:"B+E"}, {value:"c",label:"C"}, {value:"ce",label:"C+E"}, {value:"d",label:"D"}, {value:"de",label:"D+E"} ]  }, width:150, valueGetter:(params)=> {
                    const options={"a":"A", "b":"B", "bauto":"B AUTO", "be":"B+E", "c":"C", "ce":"C+E", "d":"D", "de":"D+E"} ;
                    if (!options[params.value]) return "Non impostato";
                    return options[params.value];
                } }
            ], 
            "initialState":{
                columns: {
                    columnVisibilityModel: {
                        id:false,
                        candidato:false,                        
                        istruttore:false
                    }
                }
            }
           
        }
    }
};
obj.views.tableCandidato={...obj.views.table};
obj.views.tableCandidato.showTitle=false;
obj.views.tableCandidato.fieldList=[...obj.views.table.fieldList];
obj.views.tableCandidato.autoLoad=false;
obj.views.tableCandidato.filter=false;
delete obj.views.tableCandidato.fieldList[1];
obj.views.tableIstruttore={...obj.views.table};
obj.views.tableIstruttore.showTitle=false;
obj.views.tableIstruttore.fieldList=[...obj.views.table.fieldList];
obj.views.tableIstruttore.autoLoad=false;
obj.views.tableIstruttore.filter=false;

//delete obj.views.table.fieldList[3]["filter"];
delete obj.views.table.fieldList[4]["filter"];
//delete obj.views.tableIstruttore.fieldList[2];
app.collections_config["guide"]=obj;
console.log("Guide Config",app.collections_config["guide"]);
function getIstruttoreNameBreve(docGuida) {
  /* istruttoreBreve, istruttoreCognome, istruttoreNome */
  return docGuida.istruttoreNome.substring(0,1)+docGuida.istruttoreCognome.substring(0,1);

}
function getGuideTable(table,category) {
    const scheme=app.collections_config["guide"].questionCfg.categoryScheme[category];
    const headers=[];
    const rows=[];
   // console.log("Get Guide Table",table);
   headers.push({field: 'id', headerName: '', sortable:false, filterable:false, width: 1,renderCell: (params) => (
    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
      {params.value}
    </div>
  ),});


    headers.push({field: 'idsimple', headerName: '', sortable:false, filterable:false, width: 150,renderCell: (params) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {params.value}
        </div>
      ),});
      
    rows.push({'idsimple': 'Info',"isCategory":true,'id':'General-Info'});
    rows.push({'idsimple': 'Istruttore',"isCategory":false,'id':'General-Istruttore'});
    rows.push({'idsimple': 'Durata',"isCategory":false,'id':'General-Durata'});
    Object.keys(scheme).forEach(schemeCat => {
        rows.push({'idsimple': schemeCat,"isCategory":true,'id':'Cat-'+schemeCat});
        Object.keys(scheme[schemeCat]).forEach(schemeKey => {
            rows.push({'idsimple': scheme[schemeCat][schemeKey].labelScheda,"type":scheme[schemeCat][schemeKey].typeText,"isCategory":false,'id':schemeCat+"-"+scheme[schemeCat][schemeKey].key});
            
        });

    });
    table.body.forEach(row => {
      //  if (row.category===category) {
            
            headers.push({
                    field: row.date,
                headerName: dayjs(row.date).format('DD/MM/YY')+'\n'+dayjs(row.date).format('HH:mm'), 
                width: 65, 
                sortable:false,
                filterable:false, 
                headerAlign:'center', 
                align:'center', 
                renderCell: (params) => (
                    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                      {params.value}
                    </div>
                  ),
                cellClassName: (params) => {
                        if (params.value == null) {
                    return '';
                }
          
                return clsx('schedaCandidatoValue', {
                  rate_one: params.value == 1,
                  rate_two: params.value == 2,
                  rate_three: params.value == 3,
                  rate_four: params.value == 4,
                  rate_five: params.value == 5,
                  rate_checked: params.value == "X",
                  header_break_word:true
                });
              },
            });
            let i=0;
            
            rows[i][row.date]="";
            i++;
            rows[i][row.date]=getIstruttoreNameBreve(row.docData);
            i++;
            
            rows[i][row.date]=app.durate[row.docData.durata];                    
            i++;
            Object.keys(scheme).forEach(schemeCat => {
                
                rows[i][row.date]="";
                i++;
                Object.keys(scheme[schemeCat]).forEach(schemeKey => {
    //                console.log(row.date,"Cat",schemeCat,"Key",schemeKey,"Valore",row.docData.detail[schemeKey]);
                    rows[i][row.date]=renderGuidaValueText(scheme[schemeCat][schemeKey],row.docData.detail[schemeKey]);                    
                    i++;
                });
        
            });



       // }

    });
    const output={headers:headers,rows:rows};
//    console.log("Output ",output);
    return output;
}
function renderGuidaValueText(obj,value) {
    switch (obj.typeText) {
        case "Choice4Rate":
            return value;
        case "IntInput":
            return value;
        case "CheckComponent":
            return value?"X":"";
        default:
            return value;
    }
}
export { getGuideTable };
const UserCategoryForm = ({ guida, changeGuidaObj, mode }) => {
    
    const categoryScheme=guida.scheme;
    //console.log("UserCategoryForm",guida);
    if (!categoryScheme) {
        return <Typography sx={{ my: 2 }} variant="h6" component="h6">Categoria patente {guida.scheme} non gestita</Typography>;
    }

    return (
        <div>
            {Object.entries(guida.scheme).map(([group, configGroup]) => (
                <React.Fragment key={group}>
                    <Divider sx={{ my: 2 }} ></Divider>
                    <Typography sx={{ mb: 2 }}  variant="h5" component="h5"><b>{group.toUpperCase()}</b></Typography>
                    {Object.entries(configGroup).map(([key, config]) => {
                        //const Component = config.type;
                        const Component = ratingMapping[config.typeText];
                  //      console.log("Key",key);
                  //      console.log("Render "+key,guida["detail"][config.key]);
                        return (
                            <div key={key}>
                                <Component
                                    
                                    name={config.key}
                                    label={config.name}
                                    currentValue={guida["detail"][config.key]}
                                    
                                    
                                    onChange={(value) => {
                                        if (mode!="edit") return;
                                        let updatedGuida = { ...guida };
                                        updatedGuida["detail"][config.key]=value;
                                        changeGuidaObj(updatedGuida);
                                       // console.log("Guida On Change", updatedGuida);
                                    }} 
                                   
                                />
                            </div>
                        );
                    })}
                </React.Fragment>
            ))}
        </div>
    );
};

export { UserCategoryForm};